import { FC } from 'react'

import { AppTooltip } from '@/components/shared/tooltip'

type Props = {
  isSidebarExpanded: boolean
  name: string
  renderActivator: FC
}

const SidebarTooltip: FC<Props> = ({
  isSidebarExpanded,
  name,
  renderActivator
}) => {
  return (
    <AppTooltip
      disabled={isSidebarExpanded}
      text={name}
      renderActivator={renderActivator}
      offset={16}
      placement="right"
    />
  )
}

export { SidebarTooltip }
